module.exports = __webpack_public_path__ + "img/project9_18.png.92eaba0a.webp";